import Vue from 'vue'
import Lang from '~/lang'


/**
 * Then you can do stuff like this:
 *
 * {{ 'javascript.title.home' | trans }}
 * {{ 'javascript.title.welcome' | trans({ name: 'Nasirou' }) }}
 */
Vue.filter('trans', (...args) => {
    return Lang.get(...args)
})

if (document.querySelector('#qualified-foals')) {
    Vue.component('pagination', require('laravel-vue-pagination'))

    const QualifiedFoals = () => import(/* webpackChunkName: "assets/qualified-foals" */ 'FrontComponents/vue/Championship/QualifiedFoals.vue')

    Vue.config.productionTip = false
    new Vue({
        el: '#qualified-foals',
        components: {
            QualifiedFoals,
        },
    })
}
